export default "__VITE_ASSET__b728790d__"